export const ADD_TO_CART = "ADD_TO_CART";
export const UPDATE_CARTITEM_QUANTITY = "UPDATE_CARTITEM_QUANTITY";
export const DELETE_ITEM = "DELETE_ITEM";
